export default __webpack_public_path__ + "static/media/844.431b6104.gif";